import React from 'react';
import { getIframeBaseUrl } from '../api';

export const DinosureConfirm = () => (
  <iframe
    style={{ height: 'calc(100vh - 24px - 80px)', width: '100%' }}
    src={`${getIframeBaseUrl()}/issue-policy/1/confirmation`}
  ></iframe>
);
